@if (conditionForm) {
  <form [formGroup]="conditionForm" class="grid grid-cols-2 gap-3">
    <em-select
      formControlName="operator"
      [subscriptSizing]="'dynamic'"
      [label]="'SHARED_LABEL_SELECT_OPERATOR' | translate"
    >
      <ng-container emSelectTrigger>{{
        'OPERATOR_' + operatorControl?.value?.toUpperCase() | translate
      }}</ng-container>
      @for (operator of availableOperators(); track operator) {
        <em-option [value]="operator.name">
          {{ 'OPERATOR_' + operator.name.toUpperCase() | translate }}
        </em-option>
      }
    </em-select>
    @if (requireRightOperand()) {
      <em-select-operand
        [allowStaticValues]="false"
        [type]="'array'"
        [availableAttributes]="availableCustomLabels()"
        [hidePrefix]="true"
        formControlName="rightOperand"
      >
      </em-select-operand>
    }
  </form>
}
